import React from "react";
import {Route} from "react-router-dom";
import KeepAlive from "react-activation";
import ChuangShiOS from "chuangshi-os-website-component";

import SupplierGoodsIndex from "./Index";

import SupplierGoodsList from "./List";

const data = [
    <Route
        exact
        key="SupplierGoodsIndex"
        path="/supplier/index"
        render={(props) => {
            ChuangShiOS.Util.validateToken(props);

            return (
                <KeepAlive name="/supplier/index">
                    <SupplierGoodsIndex {...props} />
                </KeepAlive>
            );
        }}
    />,
    <Route
        exact
        key="SupplierGoodsList"
        path="/supplier/goods/list"
        render={(props) => {
            ChuangShiOS.Util.validateToken(props);

            return (
                <KeepAlive name="/supplier/goods/list">
                    <SupplierGoodsList {...props} />
                </KeepAlive>
            );
        }}
    />,
];

export default data;
